import React from "react";

// Two levels per tab: a root ("Sites" / "Cust IDs") and, once drilled in,
// the id that was clicked. Clicking the root navigates back up.
function Breadcrumb({ rootLabel, currentLabel, onRoot }) {
  return (
    <nav className="flex items-center gap-2 text-sm flex-wrap" aria-label="breadcrumb">
      <button
        type="button"
        className={currentLabel ? "text-blue-600 hover:underline font-medium" : "text-gray-700 font-medium"}
        onClick={onRoot}
      >
        {rootLabel}
      </button>
      {currentLabel && (
        <>
          <span className="text-gray-400">/</span>
          <span className="text-gray-700 font-medium">{currentLabel}</span>
        </>
      )}
    </nav>
  );
}

export default Breadcrumb;
